import React, { Fragment } from "react";
import { Typography, Box, Button, Link, Grid } from "@material-ui/core";
import { useStyles } from "../Theme.js";

const PolitiqueCookie = () => {
  const classes = useStyles();
  return (
    <Fragment>
      <Box
        className={classes.subHeader}
        style={{
          marginTop: 20,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: "0",
        }}
      >
        <Typography
          variant="h3"
          className={classes.subHeaderTitle}
          style={{ textAlign: "center", display: "block" }}
        >
          Politique de Cookie
        </Typography>
      </Box>
      <Typography variant="body2" style={{ padding: "0 30px" }}>
        <p>
          Le Conseil Départemental de l’Ariège utilise des cookies nécessaires
          au fonctionnement du site. Certains cookies sont dits de traçage car
          ils permettent au site internet d’identifier votre navigateur afin de
          conserver l’information de connexion à votre compte, des informations
          de votre panier, de vos préférences.
        </p>

        <p>
          Vous pouvez donner aujourd’hui des instructions sur le sort fait à vos
          données après votre décès. Pour cela merci de contacter Le Conseil
          Départemental de l’Ariègeà l'adresse contact@nattur.eu ou par courrier
          à l'adresse suivante : Hôtel du Département 5-7 rue du Cap de la Ville
          09001 FOIX Cedex
        </p>
      </Typography>
    </Fragment>
  );
};

export default PolitiqueCookie;
